/**
 * WIP User class
 * Add more properties as needed
 * Add more helper methods as needed
 * Consumed via getCurrentUser selector
 */
import type { User as UserType } from 'modules/users/types';
export default class User {
  // NOTE: these are currently marked private to prevent direct access. The intent is to centralize
  // logic associated with user here not on logic added adhoc on publicly exposed properties
  private readonly id: string;
  private readonly proProfile?: Record<string, any>;
  private readonly profileComplete?: boolean;
  private readonly email: string;
  private readonly proRegistrationStep?: string;
  private readonly requestCount?: number;
  private readonly phoneNumber?: string;
  private readonly phoneNumberShareable?: boolean;
  constructor(user: UserType) {
    this.id = user.id;
    this.proProfile = user.proProfile;
    this.profileComplete = user.profileComplete;
    this.email = user.email;
    this.proRegistrationStep = user.proRegistrationStep;
    this.requestCount = user.requestCount;
    this.phoneNumber = user.phoneNumber;
    this.phoneNumberShareable = user.phoneNumberShareable;
  }

  public getId() {
    return this.id;
  }

  public isPro() {
    return this.proProfile !== undefined;
  }

  public isClientOnly() {
    return !this.isPro();
  }

  public isProfileComplete() {
    return this.profileComplete;
  }

  public getEmail() {
    return this.email;
  }

  public hasDroppedSocialRegistration() {
    return this.proRegistrationStep === 'socialAccountLinked' && !this.requestCount;
  }
}
